/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Colstartdate3Inputs */

const zh_adminsubs_colstartdate3 = /** @type {(inputs: Adminsubs_Colstartdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始日期`)
};

const en_adminsubs_colstartdate3 = /** @type {(inputs: Adminsubs_Colstartdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Date`)
};

const es_adminsubs_colstartdate3 = /** @type {(inputs: Adminsubs_Colstartdate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de inicio`)
};

/**
* | output |
* | --- |
* | "Start Date" |
*
* @param {Adminsubs_Colstartdate3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_colstartdate3 = /** @type {((inputs?: Adminsubs_Colstartdate3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Colstartdate3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_colstartdate3(inputs)
	if (locale === "en") return en_adminsubs_colstartdate3(inputs)
	return es_adminsubs_colstartdate3(inputs)
});
export { adminsubs_colstartdate3 as "adminSubs_colStartDate" }